"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortHumanReadable = exports.quantityFormatter = exports.pluralize = exports.makePresentable = void 0;
const core_services_1 = require("@iotv/core-services");
Object.defineProperty(exports, "pluralize", { enumerable: true, get: function () { return core_services_1.pluralize; } });
const naming_1 = require("./naming");
const makePresentable = (str, valueOverrides) => {
    if (valueOverrides?.[str])
        return valueOverrides[str];
    return (0, naming_1.capitalize)(str);
};
exports.makePresentable = makePresentable;
/** Formats a string with quantity in mind
 * @example (1, "time") => "1 time"; (2, "time") => "2 times"
 * */
const quantityFormatter = (quantity, countWord) => {
    return `${quantity} ${quantity === 1 ? countWord : (0, core_services_1.pluralize)(countWord)}`;
};
exports.quantityFormatter = quantityFormatter;
const sortHumanReadable = (list, key) => {
    return list.sort((a, b) => {
        let aRes = a[key];
        let bRes = b[key];
        if (typeof aRes === 'string' && typeof bRes === 'string') {
            return aRes.localeCompare(bRes, undefined, {
                numeric: true,
                sensitivity: 'base',
            });
        }
        return 0;
    });
};
exports.sortHumanReadable = sortHumanReadable;
